<template lang="pug">
el-dialog.newDialog(center='', :title='title', :visible='showvisible', width='720px',:show-close="false",:close-on-click-modal="false")
    .editFormDialog 
        el-form(label-position='right', size='mini', label-width='130px', :model='baseForm',  :rules="ruleArr", ref="baseForm")
            el-form-item(label='所属社区:',prop="")
                el-input(:disabled='readonly', v-model='baseForm.communityName', placeholder='',disabled)  
 
            el-form-item(label='所属网格:',prop="")
                el-input(:disabled='readonly', v-model='baseForm.orgName', placeholder='',disabled)  
 
            el-form-item(label='网格员:',prop="")
                el-input(:disabled='readonly', v-model='baseForm.name', placeholder='',disabled)  
 
 
            el-form-item(label='走访主题:',prop="title")
                el-input(:disabled='readonly', type="textarea" v-model='baseForm.title', placeholder='')  
            
            el-form-item(label='处理事项:',prop="handleMatter")
                el-input(:disabled='readonly', type="textarea" v-model='baseForm.handleMatter', placeholder='')
                //- quillEditorCom(:readonly="readonly",:fahertext.sync="baseForm.handleMatter")
 
            el-form-item(label='居民心声:',prop="residentVoice")
                el-input(:disabled='readonly', type="textarea" v-model='baseForm.residentVoice', placeholder='')
                //- quillEditorCom(:readonly="readonly",:fahertext.sync="baseForm.residentVoice")
                
            el-form-item(label='今日总结:',prop="todaySummary")
                el-input(:disabled='readonly', type="textarea" v-model='baseForm.todaySummary', placeholder='')
                //- quillEditorCom(:readonly="readonly",:fahertext.sync="baseForm.todaySummary")

        .dialog-footer(slot='footer')
            el-button(v-if='!readonly' type='primary', size='small',  @click='saveNext') 保存
            el-button(type='info', size='small', @click='dialogClose') 取消

 

</template>

<script>
import { gridLogApi } from "@/api/http";

import quillEditorCom from "@/components/quillEditorCom.vue";
import { post } from "@/api/requrestHttp"
export default {
  name: "editFormDialog",
  props: ["readonly", "show", "fatherid", "fatherdata", "pagetype"],
  components: { quillEditorCom },
  data() {
    return {
      cascaderProps: {
        value: "id",
        label: "typesName",
        children: "childTypes"
      },
      cascaderKey: 0,
      cascaderData: [],
      fileLists: [],
      ruleArr: {
        title: [{ required: true, message: "请输入", trigger: "blur" }],
        content: [{ required: true, message: "请输入", trigger: "blur" }]
      },

      values: "1",
      baseForm: {},
      treeDialog: {
        show: "",
        readonly: false,
        fatherdata: null,
        fatherid: null
      },
      userInfo: {}
    };
  },
  computed: {
    showvisible() {
      if (this.show == "add") {
        //   userInfo
        if (this.fatherid) {
          let newbaseForm = this.fatherdata;

          this.baseForm = newbaseForm;
        }
        // console.log(this.$store.state.info);
        this.baseForm.orgName = this.$store.state.info.orgName;
        this.baseForm.gridId = this.$store.state.info.orgId;
        this.baseForm.communityId = this.$store.state.info.committeeCode;
        this.baseForm.communityName = this.$store.state.info.communityName;
        this.baseForm.streetName = this.$store.state.info.streetName;
        // this.baseForm.streetCode = this.$store.state.info.streetCode;
        this.baseForm.orgLevel = this.$store.state.info.orgLevel;
        this.baseForm.name = this.$store.state.info.name;
        this.baseForm.ppId = this.$store.state.info.ppId;

        return true;
      }
      return false;
    },
    title() {
      if (this.fatherid) {
        if (this.readonly) return "查看";
        return "编辑";
      }

      return "新增";
    },
    readOnly2() {
      //   console.log(this.readonly);
      if (this.readonly) {
        return true;
      }
      return false;
    }
  },
  methods: {
    showTreeDataDialog() {
      this.treeDialog = {
        show: "show",
        readonly: false,
        fatherdata: null,
        fatherid: null
      };
    },
    dialogReback(val) {
      this.treeDialog = {
        show: "",
        readonly: false,
        fatherdata: null,
        fatherid: null
      };
    },
    dialogClose(val) {
      let text = "close";
      if (val) text = val;
      this.$emit("func", {
        dialog: text,
        data: ""
      });

      this.resetData();
    },
    resetData() {
      this.baseForm = {};
      this.baseForm.orgName = this.$store.state.info.orgName;
      this.baseForm.orgId = this.$store.state.info.orgId;
      this.baseForm.committeeCode = this.$store.state.info.committeeCode;
      this.baseForm.communityName = this.$store.state.info.communityName;
      this.baseForm.streetName = this.$store.state.info.streetName;
      this.baseForm.streetCode = this.$store.state.info.streetCode;
      this.baseForm.orgLevel = this.$store.state.info.orgLevel;
      this.baseForm.name = this.$store.state.info.name;
      this.baseForm.ppId = this.$store.state.info.ppId;
      this.$refs.baseForm.resetFields();
    },

    //根据输入地址转换经纬度并标记
    saveNext() {
      // console.log(this.baseForm)
      post('/admin/gridLog/info/insert', {
        ...this.baseForm
      }).then(res => {
        if(res.code == 200){
            this.$message({
                message:'添加成功',
                type:'success'
            });
            this.dialogClose("success")
        }
      })
        // let result = await this.$post('/admin/gridLog/info/insert',this.baseForm)
        // if(result.code == 200){
        //     this.$message({
        //         message:'添加成功',
        //         type:'success'
        //     });
        //     this.dialogClose("success")
        // }

    //   this.$refs.baseForm.validate(valid => {
    //     if (valid) {
    //       this.saveNext2();
    //     } else {
    //       //   console.log("error submit!!");
    //       return false;
    //     }
    //   });
    },
    //弹框保存
    async saveNext2() {
      let apidata = JSON.parse(JSON.stringify(this.baseForm));

      let apiText = "添加";
      let apiRes = "";

      if (apidata.id) {
        apiText = "编辑";
        apiRes = await gridLogApi.updata(apidata);
      } else {
        apiText = "新增";
        apiRes = await gridLogApi.insert(apidata);
      }

      if (apiRes && apiRes.code == 200) {
        this.$message({
          message: apiText + "成功",
          type: "success"
        });
        this.dialogClose("success");
        return;
      }

      this.$message({
        message: apiText + "失败",
        type: "error"
      });
    },
    //上传
    handleExceed(files, fileList) {
      var selected = files.length;
      var totalselected = selected + fileList.length;
      this.$message.warning(
        "当前限制选择10个文件，本次选择了" +
          selected +
          "个文件，共选择了" +
          totalselected +
          "个文件"
      );
    },
    //确保每次只能上传一个文件，可多次上传
    uploadSuccess(response, file, fileList) {
      //   console.log(response);

      if (response.code == 200) {
        this.fileLists.push({
          name: response.content.name,
          url: response.content.path
        });
      }
    },
    handleRemove(file, fileList) {
      this.fileLists = fileList;
    },
    //附件预览
    handlePreview(file) {
      console.log(file);

      window.open(file.url);
    },
    handleCascaderChange(value) {
      //   console.log(this.$refs.searchArea.getCheckedNodes()[0].data);
    },

    // 超过3级,不能选中,子级分类最多4级
    /**
     * count: 当前层级
     * data: 当前层级的数据
     * maxNum: 最多不能超过几级
     */
    setDisable(count, data, maxNum) {
      if (count > maxNum) {
        //最多几级就写几
        data.forEach(v => {
          v.disabled = true; // 超过设定的最大级数,给这一集的数据添加disabled属性
        });
      } else {
        data.forEach(v => {
          v.count = count; // 设置最外层数据的初始count

          if (v.childs && v.childs.length) {
            v.count++;
            this.setDisable(v.count, v.childs, maxNum); // 子级循环时把这一层数据的count传入
          }
        });
      }
    }
  },
  mounted() {},
  created() {}
};
</script>
<style lang="less" >
.editFormDialog {
  .dialog-footer {
    text-align: center;
  }
}
</style>